// extracted by mini-css-extract-plugin
export default {"popupContainer":"Popup_popupContainer__dRW5z","conatinerBody":"Popup_conatinerBody__aQp6E","containeFullBody":"Popup_containeFullBody__fsepP"};